module.exports = __webpack_public_path__ + "static/img/egg_r_03.e4a783f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/r/egg_r_03.png
// module id = 605c
// module chunks = 1